var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowAdvancementHistoric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 5,
    viewBox: "0 0 11 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 5L5.5 0L10.5 5H0.5Z",
    fill: "#4865CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowAdvancementHistoric);
export default __webpack_public_path__ + "static/media/show-advancement-historic.c7e440aa2bb3a4f3aef3918bc26496f9.svg";
export { ForwardRef as ReactComponent };